<template>

  <div>
     <b-modal hide-footer no-close-on-backdrop v-model="modalShow" size="xl" :title="'Conductor a autorizar: '+driver.firstName + ' ' + driver.lastName ">
      <div>
        <b-row>
      <b-col md="6" class="my-1">
       <!-- <b-alert v-if="errorAuthorized" show variant="danger">{{ errorAuthorized }}</b-alert> -->
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar concesión"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getNotAllowedConcesionesByConcesionarioIdAndDriverId"
      :fields="fields"
      :current-page="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
     <template v-slot:cell(acciones)="row">
        <b-button class="btn-sm" :disabled="autorizando" variant="outline-info" @click="authorizeConcessionDriver({data: row.item})">Autorizar</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          align="right"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="autorizando">
        <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
     </b-modal>
      <!--<b-modal hide-footer  v-model="confirmAuth" :title="messageAuth">
      </b-modal>-->
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="cardIdDriver" class="form-control" placeholder="Buscar número de tarjetón"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!cardIdDriver" @click="cardIdDriver = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="w-100" v-if="getDriverByCardId">
        <hr>
        <b-row align-v="center">
            <b-col sm="4">
                    {{driver.firstName}}
            </b-col>
    <b-col sm="4">
            {{driver.lastName}}
    </b-col>
    <b-col sm="4">
        <b-button
        class="btn-sm"
        variant="outline-info"
        @click="modalShow=!modalShow"
        >
            Autorizar concesiones para conductor
        </b-button>
    </b-col>
        </b-row>
          <hr>
    </div>
    <div class="text-center" v-if="$apollo.queries.getDriverByCardId.loading">
        <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
    </div>
    <div  v-if="checkedAuth">
        <h1>Autorización de conductores y concesiones</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filterAuthorized" class="form-control" placeholder="Buscar conductor"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filterAuthorized" @click="filterAuthorized = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <div class="space"></div>
      <b-row align-v="center">
 <b-form-checkbox v-model="checkedAuth" name="check-button" switch>
      Autorizados
    </b-form-checkbox>
      </b-row>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getConcesionDriverByConcesionarioId"
      :fields="fieldsAuthorized"
      :current-page="currentPageAuthorized"
      :per-page="perPageAuthorized"
      :filter="filterAuthorized"
      :sort-by.sync="sortByAuthorized"
      :sort-desc.sync="sortDescAuthorized"
      :sort-direction="sortDirectionAuthorized"
      @filtered="onFilteredAuthorized"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(accionesAuthorized)="row">
        <b-button v-if="row.item.authorize == 1" class="btn-sm"  variant="outline-danger" @click="unAuthorizeConcessionDriver({data: row.item})">Desautorizar</b-button>
        <b-button class="btn-sm" variant="outline-info" @click="getDetails({ data: row.item })">Detalle</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPageAuthorized"
          :total-rows="totalRowsAuthorized"
          align="right"
          :per-page="perPageAuthorized"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getConcesionDriverByConcesionarioId.loading">
        <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
    <div v-if="!checkedAuth">
        <h1>Conductores</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filterUnAuthorized" class="form-control" placeholder="Buscar conductor"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filterUnAuthorized" @click="filterUnAuthorized = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <div class="space"></div>
      <b-row align-v="center">
 <b-form-checkbox v-model="checkedAuth" name="check-button" switch>
      Desautorizados
    </b-form-checkbox>
      </b-row>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getNotallowedDrivers"
      :fields="fieldsAuthorized"
      :current-page="currentPageUnAuthorized"
      :per-page="perPageUnAuthorized"
      :filter="filterUnAuthorized"
      :sort-by.sync="sortByUnAuthorized"
      :sort-desc.sync="sortDescUnAuthorized"
      :sort-direction="sortDirectionUnAuthorized"
      @filtered="onFilteredUnAuthorized"
      empty-text="No existen registros por mostrar"
    >
      <template v-slot:cell(accionesAuthorized)="row">
        <b-button class="btn-sm" variant="outline-info" @click="AuthorizeConcessionDriverAgain({data: row.item})">Autorizar</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPageUnAuthorized"
          :total-rows="totalRowsUnAuthorized"
          align="right"
          :per-page="perPageUnAuthorized"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getNotallowedDrivers.loading">
        <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
    </div>
    </div>
    </div>
</template>

<script>
import headers from '@/config/headers.js'
import gql from 'graphql-tag'
export default {
  data() {
    return {
      fields: [
        { key: 'concesionNumber', label: 'Concesión' },
        { key: 'vehicle.model', label: 'Modelo Vehículo' },
        { key: 'vehicle.licensePlate', label: 'Placa del vehículo' },
        { key: 'acciones', label: 'Acciones' },
      ],
      fieldsAuthorized: [
        { key: 'driver.cardId', label: 'Número de tarjetón', sortable: true, sortDirection: 'desc' },
        { key: 'driver.firstName', label: 'Nombre' },
        { key: 'driver.lastName', label: 'Apellidos' },
        { key: 'driver.license', label: 'Número de licencia' },
        { key: 'concesion.concesionNumber', label: 'Concesión autorizada' },
        { key: 'accionesAuthorized', label: 'Acciones' },
      ],
      totalRows: 1,
      totalRowsAuthorized: 1,
      totalRowsUnAuthorized: 1,
      currentPage: 1,
      currentPageAuthorized: 1,
      currentPageUnAuthorized: 1,
      perPage: 10,
      perPageAuthorized: 10,
      perPageUnAuthorized: 10,
      pageOptions: [5, 10, 15],
      pageOptionsAuthorized: [5, 10, 15],
      pageOptionsUnAuthorized: [5, 10, 15],
      sortBy: null,
      sortByAuthorized: null,
      sortByUnAuthorized: null,
      sortDesc: false,
      sortDescAuthorized: false,
      sortDescUnAuthorized: false,
      sortDirection: 'asc',
      sortDirectionAuthorized: 'asc',
      sortDirectionUnAuthorized: 'asc',
      filter: null,
      filterAuthorized: null,
      filterUnAuthorized: null,
      cardIdDriver: '',
      driver: {
        firstName: '',
        lastName: '',
        id: 0,
      },
      modalShow: false,
      dataLoad: -1,
      autorizando: false,
      errorAuthorized: null,
      confirmAuth: false,
      messageAuth: '',
      checkedAuth: true,
    }
  },
  apollo: {
    // Query with parameters
    getDriverByCardId: {
      query: gql`query getDriverByCardId ($cardId: String!) {
          getDriverByCardId (cardId: $cardId){
              id
              firstName
              lastName
          }
    }`,
      context: headers(),
      // Reactive parameters
      variables () {
        // Use vue reactive properties here
        return {
          cardId: this.cardIdDriver,
        }
      },
      error (erro) {
        // console.log('Ocurrió un error')
        // console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getDriverByCardId) {
          this.driver = data.getDriverByCardId
          console.log(this.driver)
        } else {
          this.driver = {
            firstName: '',
            lastName: '',
            id: 0,
          }
        }
      },
    },
    getNotAllowedConcesionesByConcesionarioIdAndDriverId: {
      query: gql`query getNotAllowedConcesionesByConcesionarioIdAndDriverId ($concesionarioId: Int!, $driverId: Int!) {
          getNotAllowedConcesionesByConcesionarioIdAndDriverId (concesionarioId: $concesionarioId driverId: $driverId ){
            id
            concesionNumber
            concesionario{
            name
            rfc
            }
            vehicle{
            id
            brand
            licensePlate
            model
            serialNumber
            }
            active
          }
        }`,
      context: headers(),
      variables () {
        return {
          concesionarioId: this.dataLoad,
          driverId: parseInt(this.driver.id),
        }
      },
      error (erro) {
        // console.log('Ocurrió un error')
        // console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        // console.log('getConcesionByConcesionario')
        console.log(data)
        if (data.getNotAllowedConcesionesByConcesionarioIdAndDriverId) {
          this.totalRows = data.getNotAllowedConcesionesByConcesionarioIdAndDriverId.length
        }
      },
    },
    getConcesionDriverByConcesionarioId: {
      query: gql`query getConcesionDriverByConcesionarioId ($concesionarioId: Int!) {
          getConcesionDriverByConcesionarioId (concesionarioId: $concesionarioId){
            driver {
              id
              cardId
              firstName
              lastName
              license
            }
            concesion {
              id
              concesionNumber
            }
            authorize
          }
        }`,
      context: headers(),
      variables () {
        return {
          concesionarioId: this.dataLoad,
        }
      },
      error (erro) {
        this.makeToast(true, 'danger', 'error', 'Ocurrió un error, Inténtalo de nuevo.')
        // console.log('Ocurrió un error')
        // console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getConcesionDriverByConcesionarioId) {
          // console.log(data.getConcesionDriverByConcesionarioId)
          this.totalRowsAuthorized = data.getConcesionDriverByConcesionarioId.length
        }
      },
    },
    getNotallowedDrivers: {
      query: gql`query getNotallowedDrivers ($concesionarioId: Int!) {
          getNotallowedDrivers (concesionarioId: $concesionarioId){
            driver {
              id
              cardId
              firstName
              lastName
              license
            }
            concesion {
              id
              concesionNumber
            }
            authorize
          }
        }`,
      context: headers(),
      variables () {
        return {
          concesionarioId: this.dataLoad,
        }
      },
      error (erro) {
        this.makeToast(true, 'danger', 'error', 'Ocurrió un error, intentalo de nuevo.')
        // console.log('Ocurrió un error')
        // console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getNotallowedDrivers) {
          // console.log(data.getNotallowedDrivers)
          this.totalRowsUnAuthorized = data.getNotallowedDrivers.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFilteredAuthorized(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsAuthorized = filteredItems.length
      this.currentPageAuthorized = 1
    },
    onFilteredUnAuthorized(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsUnAuthorized = filteredItems.length
      this.currentPageUnAuthorized = 1
    },
    async authorizeConcessionDriver(auth) {
      // console.log(data.franchisee)
      this.autorizando = true
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: gql`mutation authorizeConcesionDriver($driverId: Int, $concesionId: Int) {
         authorizeConcesionDriver(concesionDriver: {
          driverId: $driverId
          concesionId: $concesionId
        }){
          authorize
        }
        }`,
        context: headers(),
        variables: {
          driverId: parseInt(this.driver.id),
          concesionId: parseInt(auth.data.id),
        },
      })
        .then(res => {
          // this.modalShow = false
          this.makeToast(true, 'success', 'Autorización correcta', 'Conductor autorizado correctamente.')
          this.confirmAuth = true
          this.autorizando = false
          this.dataLoad = parseInt(this.getFranchisee)
        })
        .catch(error => {
          // console.log(error)
          if (error) {
            this.makeToast(true, 'danger', 'Error', 'Ocurrió un error, verifica que el conductor no esté autorizado y tengas conexión a internet.')
            this.autorizando = false
            this.dataLoad = parseInt(this.getFranchisee)
          }
        })
    },
    async reloadDataDrivers() {
      this.dataLoad = 0
    },
    getDetails(driver) {
      console.log(driver)
      this.$router.push('/conductores/getDriver/' + driver.data.driver.id)
    },
    async unAuthorizeConcessionDriver(disable) {
      // console.log(disable.data.driver.id)
      // console.log(disable.data.concesion.id)
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: gql`mutation restrictConcesionDriver($driverId: Int, $concesionId: Int) {
          restrictConcesionDriver(
          driverId: $driverId
          concesionId: $concesionId
          ){
          authorize
        }
        }`,
        context: headers(),
        variables: {
          driverId: parseInt(disable.data.driver.id),
          concesionId: parseInt(disable.data.concesion.id),
        },
      })
        .then(res => {
          this.makeToast(true, 'success', 'Desautorización correcta', 'Conductor desautorizado correctamente.')
          this.confirmAuth = true
          this.dataLoad = parseInt(this.getFranchisee)
          // console.log(disable.data)
        })
        .catch(error => {
          if (error) {
            this.dataLoad = parseInt(this.getFranchisee)
            this.makeToast(true, 'danger', 'error', 'Ocurrió un error, Inténtalo de nuevo.')
          }
          // console.log(error)
          // console.log('algo salio mal')
        })
    },
    async AuthorizeConcessionDriverAgain(authAgain) {
      // console.log(authAgain.data.concesion.id)
      // console.log(authAgain.data.driver.id)
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: gql`mutation updateDriverauthorizeallowed($driverId: Int, $concesionId: Int) {
          updateDriverauthorizeallowed(
          driverId: $driverId
          concesionId: $concesionId
          ){
          message
        }
        }`,
        context: headers(),
        variables: {
          driverId: parseInt(authAgain.data.driver.id),
          concesionId: parseInt(authAgain.data.concesion.id),
        },
      })
        .then(res => {
          this.makeToast(true, 'success', 'Autorización correcta', 'Conductor autorizado correctamente.')
          this.confirmAuth = true
          this.dataLoad = parseInt(this.getFranchisee)
          // console.log(disable.data)
        })
        .catch(error => {
          if (error) {
            this.dataLoad = parseInt(this.getFranchisee)
            this.makeToast(true, 'danger', 'error', 'Ocurrió un error, Inténtalo de nuevo.')
          }
          // console.log(error)
          // console.log('algo salio mal')
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  created: function () {
    // `this` hace referencia a la instancia vm
    this.dataLoad = parseInt(this.getFranchisee)
    console.log(this.getFranchisee)
  },
  computed: {
    getFranchisee() {
      return this.$store.state.user.franchisee
    },
  },
}
</script>
<style>
.space {
  width: 10px;
}
</style>
